import * as React from "react";
import { SVGProps } from "react";
const SvgLogoGoogleDrive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-google-drive_svg__a)">
      <path d="m3 16.638 3-5.213h12l-3 5.213H3Z" fill="#3777E3" />
      <path d="M12 11.425h6L12 1H6l6 10.425Z" fill="#FFCF63" />
      <path d="m0 11.425 3 5.213L9 6.213 6 1 0 11.425Z" fill="#11A861" />
    </g>
    <defs>
      <clipPath id="logo-google-drive_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoGoogleDrive;
